import { format } from "date-fns";
import DATE_FORMAT from "../config/date-config";

export const getFileNameWithDate = (prefix, type = "xlsx", date = new Date()) => {
  const formattedDate = format(new Date(), DATE_FORMAT.DATE);
  return `${prefix}_${formattedDate}.${type}`;
}

export const getFileNamePrefixWithDate = (prefix, date = new Date()) => {
  const formattedDate = format(new Date(), DATE_FORMAT.DATE);
  return `${prefix}_${formattedDate}`;
}